export default __webpack_public_path__ + "static/media/hero.41c985b0.jpg";